import React from 'react';
import '../../styles.scss'

const Main = (props) => {
    return (
                <div className={'text__white regular-text-700 main-page-text-container'}>
                    <span >
                        Тылсымлы китап – битләрен ачу мөмкинлеге булган интерактив китаптан гыйбарәт проект ул. Әлеге китап тавышландырылган, димәк аны тыңлау мөмкинлеге дә бар. Шулай ук китаптагы рәсемнәрне зурайтып карарга була. Китапны уку барышында видеоөзекләр карап алырга да мөмкин.
                    </span>
                </div>
    )
};

export default Main;
